import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { getColorAdv, getColorDueDate, getTextColorByHexColor } from 'common/utils/ColorUtil'
import { getDate } from 'common/utils/DateUtil'
import { ticketsLabel } from './DevLotsUtils'

const NEUTRAL_PILL = '#eef1f5'
const NO_URGENCY = '#fff'

const progressSx = (value) => ({
    height: '8px',
    borderRadius: '4px',
    [`&.${linearProgressClasses.colorPrimary}`]: { backgroundColor: '#e4e9f0' },
    [`& .${linearProgressClasses.bar}`]: { backgroundColor: getColorAdv(value) },
})

const Pill = ({ children, color = NEUTRAL_PILL }) => (
    <Box sx={{ px: 1, py: '2px', borderRadius: '10px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', backgroundColor: color, color: color === NEUTRAL_PILL ? '#33405c' : getTextColorByHexColor(color) }}>
        {children}
    </Box>
)
Pill.propTypes = { children: PropTypes.node, color: PropTypes.string }

const HeaderAction = ({ icon, tooltip, onClick }) => (
    <Tooltip title={tooltip}>
        <IconButton size='small' onClick={onClick}><Icon sx={{ color: '#33405c', fontSize: 22 }}>{icon}</Icon></IconButton>
    </Tooltip>
)
HeaderAction.propTypes = { icon: PropTypes.string, tooltip: PropTypes.string, onClick: PropTypes.func }

// En-tête d'un lot du suivi (nouveau design) : nom, pastilles (tickets, temps, échéance), avancement et actions discrètes.
const LotHeader = ({ name, nbTickets = 0, dueDate, spentTime = 0, estimateTime = 0, average = 0, lotAction, actions = [] }) => {
    const dueColor = dueDate ? getColorDueDate(dueDate * 1000) : NO_URGENCY
    return (
        <Stack direction='row' alignItems='center' spacing={1.5} sx={{ width: '100%' }}>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#1c2340' }}>{name}</Typography>
            <Pill>{ticketsLabel(nbTickets)}</Pill>
            {(spentTime > 0 || estimateTime > 0) && <Pill>{`${spentTime}h / ${estimateTime}h`}</Pill>}
            {!!dueDate && <Pill color={dueColor === NO_URGENCY ? NEUTRAL_PILL : dueColor}>{`Échéance ${getDate(dueDate * 1000)}`}</Pill>}
            <Box sx={{ flex: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: 190 }}>
                <Box sx={{ flex: 1 }}><LinearProgress variant='determinate' value={average} sx={progressSx(average)} /></Box>
                <Typography sx={{ fontSize: 13, fontWeight: 700, width: 38, textAlign: 'right', color: '#1c2340' }}>{`${average}%`}</Typography>
            </Box>
            <Stack direction='row' spacing={1}>
                {!!lotAction && <HeaderAction {...lotAction} />}
                {actions.map(a => <HeaderAction key={a.icon} {...a} />)}
            </Stack>
        </Stack>
    )
}

export { Pill, progressSx }

LotHeader.propTypes = {
    name: PropTypes.string,
    nbTickets: PropTypes.number,
    dueDate: PropTypes.number,
    spentTime: PropTypes.number,
    estimateTime: PropTypes.number,
    average: PropTypes.number,
    lotAction: PropTypes.shape({ icon: PropTypes.string, tooltip: PropTypes.string, onClick: PropTypes.func }),
    actions: PropTypes.arrayOf(PropTypes.shape({ icon: PropTypes.string, tooltip: PropTypes.string, onClick: PropTypes.func })),
}

export default LotHeader
